import { SetStateAction, useCallback, useContext, useEffect, useState, useRef } from "react";
import { Button, Checkbox, FormControlLabel, FormGroup, MenuItem, Paper, Select, Snackbar, TableContainer, TextField, Toolbar, Typography } from "@mui/material";
import React from "react";
import { CustomTextField, CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { useLocation } from "react-router-dom";
import { del, get, post, post_file } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { IZonaHomogenea } from "../../../Interfaces/cadernos/zona_homogenea";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { Alert } from "../../../Components/Alert/Alert";
import LoadingVulpesSmall from "../../../Styles/Loader/loadingSmall";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { ICabecalho, IContador } from "../../../Interfaces/cadernos/caderno5/caderno5";
import BasicPopover from "../../../Components/Popover";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { docs_cadernos } from "../../../Func_genericas/hosts";
import { Modaladdeditcontador } from "../../../Componentes_modulo/modal_add_edit_contador";
import { Modalshowpdf } from "../../../Components/VerPdf/modal_show_pdf";

// index.js
interface CabecalhoForm_prop {
  set_obj_anexo_cabecalho_selecionado: React.Dispatch<SetStateAction<ICabecalho | undefined>>;
  obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
}

export const CabecalhoForm: React.FC<CabecalhoForm_prop> = ({
  obj_anexo_cabecalho_selecionado
  , set_obj_anexo_cabecalho_selecionado }) => {
  const auth = useContext(AuthContext);

  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [especie_ou_lote_homegenio_selecionada, set_especie_ou_lote_homegenio_selecionada] = useState<IZonaHomogenea>();
  const [especie_ou_lote_homegenio_lista, set_especie_ou_lote_homegenio_lista] = useState<IZonaHomogenea[]>([]);
  const [cultura_selecionada, set_cultura_selecionada] = useState<any>();

  const [obj_anexo_cabecalho, set_obj_anexo_cabecalho] = useState<ICabecalho>();
  const [obj_anexo_cabecalho_lista, set_obj_anexo_cabecalho_lista] = useState<ICabecalho[]>();
  const [obj_anexo_cabecalho_to_edit, set_obj_anexo_cabecalho_to_edit] = useState<ICabecalho>();
  const [obj_anexo_cabecalho_backup, set_obj_anexo_cabecalho_backup] = useState<ICabecalho | undefined>(undefined);

  const [lista_contadores, set_lista_contadores] = useState<IContador[]>();
  const [contador_selecionado, set_contador_selecionado] = useState<IContador | undefined>();

  const [flag_criar_contador, set_flag_criar_contador] = useState<boolean>(false);

  const [open_modal_add_edit_contador, set_open_modal_add_edit_contador] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [message, setMessage] = useState("");
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState<boolean>(false);

  const [flag_editar_cabecalho, set_flag_editar_cabecalho] = useState<boolean>(false)

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);
  const [error_producao_total, set_error_producao_total] = React.useState<boolean>(false);
  const [error_esperada, set_error_esperada] = React.useState<boolean>(false);
  const [error_obtida, set_error_obtida] = React.useState<boolean>(false);
  const [error_n_contador, set_error_n_contador] = React.useState<boolean>(false);
  const [error_leitura_contador_preimeira, set_error_leitura_contador_preimeira] = React.useState<boolean>(false);
  const [error_n_plantas, set_error_n_plantas] = React.useState<boolean>(false);


  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const [isEditingCultura, setIsEditingCultura] = useState(false);

  const handleCloseDialog = () => {
    set_error_esperada(false)
    set_error_leitura_contador_preimeira(false)
    set_error_n_contador(false)
    set_error_obtida(false)
    set_error_producao_total(false)
    set_error_n_plantas(false)
    if (obj_anexo_cabecalho_backup) {
      set_obj_anexo_cabecalho_to_edit(obj_anexo_cabecalho_backup); // restaura o estado original
    }
    set_flag_editar_cabecalho(false)

    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState("");
  const [open_dialog_eliminar_ficheiro, set_open_dialog_eliminar_ficheiro] = useState(false);
  const [open_dialog_editar_ficheiro, set_open_dialog_editar_ficheiro] = useState(false);
  const [open_modal_show_pdf, set_open_modal_show_pdf] = useState(false);
  const [pdf_link, set_pdf_link] = useState("");
  const fileInputRef = useRef<HTMLInputElement>(null);

  const uploadDocumento = async (selectedFile: File) => {
    if (!selectedFile) {
      setMessage("Nenhum ficheiro selecionado.");
      setOpenSnackError(true);
      return;
    }

    if (!obj_anexo_cabecalho || !obj_anexo_cabecalho.id_regsto_oper_cult_cabecalho) {
      setMessage("Impossível carregar o documento antes de criar cabeçalho.");
      setOpenSnackError(true);
      return;
    }

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);

      const response = await post_file(auth.token.cookie_token, `/uploadFile5/${obj_anexo_cabecalho?.id_regsto_oper_cult_cabecalho}`, formData);

      if (response.status === 200) {
        setMessage("Documento carregado com sucesso!");
        setOpenSnackSuccess(true);
        setFileName(response.data.result.file)
        setSelectedFile(new File([], response.data.result.file, { type: 'application/pdf' }));

        let aux = obj_anexo_cabecalho_lista?.map((el) => {
          if (el.id_regsto_oper_cult_cabecalho === response.data.result.id_regsto_oper_cult_cabecalho) {
            return response.data.result
          } else {
            return el
          }
        })

        set_obj_anexo_cabecalho_lista(aux)
      } else {
        setMessage("Erro ao carregar documento.");
        setOpenSnackError(true);
      }
    } catch (error: any) {
      func_print("uploadDocumento", error, true);
      // if (error?.status === 409) {

      //   setMessage(error?.response.data.detail);
      //   setOpenSnackError(true);
      // } else {
      //   setMessage("Erro ao efetuar a sua operação!");
      //   setOpenSnackError(true);
      // }

      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setIsLoading(false);
      setOpenSnackError(true);

    } finally {
      setIsLoading(false);
    }

  };

  const onInputEditTableChange_cabecalho = (event: any) => {
    const { name, value, type, checked } = event.target;
    //let aux_obj_anexo: any = obj_anexo_cabecalho_to_edit === undefined ? {} : obj_anexo_cabecalho_to_edit;
    set_flag_editado(true)

    if (type === "checkbox") {
      set_obj_anexo_cabecalho_to_edit((old: any) => ({
        ...old,
        [name]: checked,
      }));
    } else {
      if (name === 'producao_total') {
        if (!/^\d+$/.test(value)) {
          set_error_producao_total(true);
        } else {
          set_error_producao_total(false);
        }
      }
      if (name === 'esperada') {
        if (!/^\d+$/.test(value)) {
          set_error_esperada(true);
        } else {
          set_error_esperada(false);
        }
      }
      if (name === 'obtida') {
        if (!/^\d+$/.test(value)) {
          set_error_obtida(true);
        } else {
          set_error_obtida(false);
        }
      }
      if (name === 'n_plantas') {
        if (!/^\d+$/.test(value)) {
          set_error_n_plantas(true);
        } else {
          set_error_n_plantas(false);
        }
      }
      if (name === 'leitura_contador_preimeira') {
        if (!/^\d+$/.test(value)) {
          set_error_leitura_contador_preimeira(true);
        } else {
          set_error_leitura_contador_preimeira(false);
        }
      }
      if (name === 'n_contador') {
        if (!/^\d+$/.test(value)) {
          set_error_n_contador(true);
        } else {
          set_error_n_contador(false);
        }
      }

      set_obj_anexo_cabecalho_to_edit((old: any) => ({
        ...old,
        [name]: value,
      }));
    }
  };

  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };
  const atualizarListaZonasComCabecalhos = (
    listaZonas: any[],
    listaCabecalhos: ICabecalho[]
  ) => {
    const resultado = listaZonas.map((zona) => ({
      ...zona,
      culturas: [...(zona.culturas ?? [])],
    }));

    listaCabecalhos.forEach((item: ICabecalho) => {
      const zona = resultado.find(
        (z) => z.zona_homogenea === item.zona_homo
      );

      const novaCultura = {
        cultura: item.cultura,
        area: item.area,
      };

      if (!zona) {
        resultado.push({
          zona_homogenea: item.zona_homo,
          culturas: [novaCultura],
        });
      } else {
        const culturaExiste = zona.culturas.some(
          (c: any) => c.cultura === item.cultura
        );

        if (!culturaExiste) {
          zona.culturas.push(novaCultura);
        }
      }
    });

    return resultado;
  };
  const get_info = useCallback(async () => {
    try {
      let res = await get(auth.token.cookie_token,
        `/zona_homgenea_caraterizacao/${location.state.id_rosto}`
        // `/get_reg_anexo_um__cabecalho_rosto/${location.state.id_rosto}`
      );
      let res_cabecalho = await get(auth.token.cookie_token,
        `/get_reg_operacoes_cabecalho__rosto/${location.state.id_rosto}`
        // `/get_reg_anexo_um_um_cabecalho/${location.state.id_rosto}`
      );
      let res_contadores = await get(auth.token.cookie_token,
        `/get_contador_idAgri/${location.state.id_agri}`
        // `/get_reg_anexo_um_um_cabecalho/${location.state.id_rosto}`
      );
      if (res_contadores.status === 200) {

        if (res_contadores.data.result.length !== 0) {
          set_lista_contadores(res_contadores.data.result)
        }
      }

      if (res.status === 200 && res_cabecalho.status === 200) {

        if (res.data.result.length !== 0) {

          const resultado = atualizarListaZonasComCabecalhos(
            res.data.result,
            res_cabecalho.data.result
          );

          set_especie_ou_lote_homegenio_lista(resultado);
          set_especie_ou_lote_homegenio_selecionada(resultado[0])
          set_cultura_selecionada(resultado[0].culturas[0])

          if (res_cabecalho.data.result.length !== 0) {
            set_obj_anexo_cabecalho_lista(res_cabecalho.data.result)
            let obj_aux = res_cabecalho.data.result?.find((el: ICabecalho) => el.zona_homo === resultado[0].zona_homogenea)

            if (obj_aux !== undefined) {
              if (obj_aux.n_contador !== null) {
                set_contador_selecionado(res_contadores.data.result.find((el: IContador) => el.id_contador.toString() === obj_aux.n_contador.toString()))

              }
              if (obj_aux.file) {
                setFileName(obj_aux.file)
                setSelectedFile(new File([], obj_aux.file, { type: 'application/pdf' }))
              }

              set_obj_anexo_cabecalho_to_edit(obj_aux)
              set_obj_anexo_cabecalho(obj_aux)
              set_obj_anexo_cabecalho_selecionado(obj_aux)
              set_obj_anexo_cabecalho_backup(obj_aux)
              set_cultura_selecionada(resultado[0].culturas.find((el: any) => el.cultura === obj_aux.cultura))

            } else {
              set_flag_editar_cabecalho(true)

            }

          } else {
            set_flag_editar_cabecalho(true)

          }
        }
      }

      setIsLoading(false);
    } catch (error) {
      func_print("get_info", error, true);
      setMessage("Erro!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  }, [auth.token.cookie_token, location.state.id_rosto, set_obj_anexo_cabecalho_selecionado]);

  const handle_change_cultura = (cultura_selecionad: string) => {


    let aux_cultura_selecionada = especie_ou_lote_homegenio_selecionada?.culturas.find((el: any) => el.cultura === cultura_selecionad)

    set_cultura_selecionada(aux_cultura_selecionada)

    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho) => el.zona_homo === especie_ou_lote_homegenio_selecionada?.zona_homogenea && aux_cultura_selecionada.cultura === el.cultura)

    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
      setFileName('')
      setSelectedFile(null);
    } else {
      set_flag_editar_cabecalho(false)

      if (obj_aux.file) {
        setFileName(obj_aux.file)
        setSelectedFile(new File([], obj_aux.file, { type: 'application/pdf' }));
      } else {
        setFileName('')
        setSelectedFile(null);
      }
    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)

  }

  const handle_change_zona_homogenea = (zona_homogenea_selecionada: string) => {
    set_obj_anexo_cabecalho_selecionado(undefined)

    const listaZonasAtualizada = atualizarListaZonasComCabecalhos(
      especie_ou_lote_homegenio_lista ?? [],
      obj_anexo_cabecalho_lista ?? []
    );
    set_especie_ou_lote_homegenio_lista(listaZonasAtualizada);


    set_contador_selecionado(undefined)
    let aux_obj_zona_homogenea_selecionada = listaZonasAtualizada.find((el: IZonaHomogenea) => el.zona_homogenea === zona_homogenea_selecionada)

    set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho) => el.zona_homo === zona_homogenea_selecionada)
    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
      setFileName('')
      setSelectedFile(null);
      set_cultura_selecionada(aux_obj_zona_homogenea_selecionada?.culturas[0])

    } else {

      if (obj_aux?.n_contador !== null) {
        set_contador_selecionado(lista_contadores?.find((el: IContador) => el.id_contador.toString() === obj_aux?.n_contador.toString()))

      }


      set_flag_editar_cabecalho(false)
      if (obj_aux.file) {
        setFileName(obj_aux.file)
        setSelectedFile(new File([], obj_aux.file, { type: 'application/pdf' }));
      } else {
        setFileName('')
        setSelectedFile(null);
      }
      set_cultura_selecionada(aux_obj_zona_homogenea_selecionada?.culturas.find((el:any) => el.cultura === obj_aux?.cultura))

    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)


  }

  const handle_change_contador = (id_contador: number) => {
    set_obj_anexo_cabecalho_selecionado(undefined)

    if (id_contador === 0) {
      set_open_modal_add_edit_contador(true)

      if (lista_contadores?.length === 0 || lista_contadores === undefined) {
        set_flag_criar_contador(true)

      }
    } else {
      let aux_obj_contador = lista_contadores?.find((el: IContador) => el.id_contador === id_contador)

      set_contador_selecionado(aux_obj_contador)
    }



  }
  const handle_criar_cabecalho = async () => {
    if (error_producao_total || error_esperada || error_obtida || error_n_plantas || error_n_contador || error_leitura_contador_preimeira) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {

      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "new_reg_operacoes_culturais_cabecalho", {
          payload: {
            id_regsto_oper_cult_cabecalho: 0,
            zona_homo: especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea,
            area: cultura_selecionada?.area === undefined ? null : cultura_selecionada?.area,
            cultura: cultura_selecionada?.cultura === undefined ? null : cultura_selecionada?.cultura,
            conversao: obj_anexo_cabecalho_to_edit?.conversao === undefined ? null : obj_anexo_cabecalho_to_edit?.conversao,
            compasso: obj_anexo_cabecalho_to_edit?.compasso === undefined ? null : obj_anexo_cabecalho_to_edit?.compasso,
            producao_total: obj_anexo_cabecalho_to_edit?.producao_total === undefined ? null : obj_anexo_cabecalho_to_edit?.producao_total,
            esperada: obj_anexo_cabecalho_to_edit?.esperada === undefined ? null : obj_anexo_cabecalho_to_edit?.esperada,
            c_1: obj_anexo_cabecalho_to_edit?.c_1 === undefined ? null : obj_anexo_cabecalho_to_edit?.c_1,
            c_2: obj_anexo_cabecalho_to_edit?.c_2 === undefined ? null : obj_anexo_cabecalho_to_edit?.c_2,
            c_3: obj_anexo_cabecalho_to_edit?.c_3 === undefined ? null : obj_anexo_cabecalho_to_edit?.c_3,
            porta_enxerto: obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? null : obj_anexo_cabecalho_to_edit?.porta_enxerto,
            n_plantas: obj_anexo_cabecalho_to_edit?.n_plantas === undefined ? null : obj_anexo_cabecalho_to_edit?.n_plantas,
            date_platacao: obj_anexo_cabecalho_to_edit?.date_platacao === undefined ? null : obj_anexo_cabecalho_to_edit?.date_platacao,
            metodo_rega: obj_anexo_cabecalho_to_edit?.metodo_rega === undefined ? null : obj_anexo_cabecalho_to_edit?.metodo_rega,
            c_e: obj_anexo_cabecalho_to_edit?.c_e === undefined ? null : obj_anexo_cabecalho_to_edit?.c_e,
            obtida: obj_anexo_cabecalho_to_edit?.obtida === undefined ? null : obj_anexo_cabecalho_to_edit?.obtida,
            // n_contador: obj_anexo_cabecalho_to_edit?.n_contador === undefined ? null : obj_anexo_cabecalho_to_edit?.n_contador,
            n_contador: contador_selecionado?.id_contador === undefined ? null : contador_selecionado?.id_contador,
            leitura_contador_preimeira: obj_anexo_cabecalho_to_edit?.leitura_contador_preimeira === undefined ? null : obj_anexo_cabecalho_to_edit?.leitura_contador_preimeira,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })
        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_obj_anexo_cabecalho(data.data.result)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          if (obj_anexo_cabecalho_lista?.length === 0 || obj_anexo_cabecalho_lista === undefined) {
            set_obj_anexo_cabecalho_lista([data.data.result])

          } else {
            set_obj_anexo_cabecalho_lista((old: any) => [...old, data.data.result])

          }
          set_error_esperada(false)
          set_error_obtida(false)
          set_error_leitura_contador_preimeira(false)
          set_error_n_contador(false)
          set_error_producao_total(false)
          set_error_n_plantas(false)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          set_obj_anexo_cabecalho_selecionado(data.data.result)
          set_obj_anexo_cabecalho_backup(data.data.result)
          set_flag_editar_cabecalho(false)
          set_flag_editado(false)
          if (data.data.result.file) {
            setFileName(data.data.result.file)
            setSelectedFile(new File([], data.data.result.file, { type: 'application/pdf' }));
          } else {
            setFileName('')
            setSelectedFile(null);
          }
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);

      } catch (error) {
        func_print('handle_criar_cabecalho', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }

  }
  const handle_editar_cabecalho = async () => {
    if (error_producao_total || error_esperada || error_obtida || error_n_plantas || error_n_contador || error_leitura_contador_preimeira) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {
      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "update_reg_operacoes_culturais_cabecalho", {
          payload: {
            id_regsto_oper_cult_cabecalho: obj_anexo_cabecalho_to_edit?.id_regsto_oper_cult_cabecalho === undefined ? null : obj_anexo_cabecalho_to_edit?.id_regsto_oper_cult_cabecalho,
            zona_homo: especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea,
            area: cultura_selecionada?.area === undefined ? null : cultura_selecionada?.area,
            cultura: cultura_selecionada?.cultura === undefined ? null : cultura_selecionada?.cultura,
            conversao: obj_anexo_cabecalho_to_edit?.conversao === undefined ? null : obj_anexo_cabecalho_to_edit?.conversao,
            compasso: obj_anexo_cabecalho_to_edit?.compasso === undefined ? null : obj_anexo_cabecalho_to_edit?.compasso,
            producao_total: obj_anexo_cabecalho_to_edit?.producao_total === undefined ? null : obj_anexo_cabecalho_to_edit?.producao_total,
            esperada: obj_anexo_cabecalho_to_edit?.esperada === undefined ? null : obj_anexo_cabecalho_to_edit?.esperada,
            c_1: obj_anexo_cabecalho_to_edit?.c_1 === undefined ? null : obj_anexo_cabecalho_to_edit?.c_1,
            c_2: obj_anexo_cabecalho_to_edit?.c_2 === undefined ? null : obj_anexo_cabecalho_to_edit?.c_2,
            c_3: obj_anexo_cabecalho_to_edit?.c_3 === undefined ? null : obj_anexo_cabecalho_to_edit?.c_3,
            porta_enxerto: obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? null : obj_anexo_cabecalho_to_edit?.porta_enxerto,
            n_plantas: obj_anexo_cabecalho_to_edit?.n_plantas === undefined ? null : obj_anexo_cabecalho_to_edit?.n_plantas,
            date_platacao: obj_anexo_cabecalho_to_edit?.date_platacao === undefined ? null : obj_anexo_cabecalho_to_edit?.date_platacao,
            metodo_rega: obj_anexo_cabecalho_to_edit?.metodo_rega === undefined ? null : obj_anexo_cabecalho_to_edit?.metodo_rega,
            c_e: obj_anexo_cabecalho_to_edit?.c_e === undefined ? null : obj_anexo_cabecalho_to_edit?.c_e,
            obtida: obj_anexo_cabecalho_to_edit?.obtida === undefined ? null : obj_anexo_cabecalho_to_edit?.obtida,
            n_contador: contador_selecionado?.id_contador === undefined ? null : contador_selecionado?.id_contador,
            // n_contador: obj_anexo_cabecalho_to_edit?.n_contador === undefined ? null : obj_anexo_cabecalho_to_edit?.n_contador,
            leitura_contador_preimeira: obj_anexo_cabecalho_to_edit?.leitura_contador_preimeira === undefined ? null : obj_anexo_cabecalho_to_edit?.leitura_contador_preimeira,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })


        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_flag_editar_cabecalho(false)
          set_error_esperada(false)
          set_error_obtida(false)
          set_error_leitura_contador_preimeira(false)
          set_error_n_contador(false)
          set_error_producao_total(false)
          set_error_n_plantas(false)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          set_obj_anexo_cabecalho(data.data.result)
          set_obj_anexo_cabecalho_selecionado(data.data.result)
          set_obj_anexo_cabecalho_backup(data.data.result)
          set_flag_editado(false)
          let aux = obj_anexo_cabecalho_lista?.map((el) => {
            if (el.id_regsto_oper_cult_cabecalho === data.data.result.id_regsto_oper_cult_cabecalho) {
              return data.data.result
            } else {
              return el
            }
          })
          set_obj_anexo_cabecalho_lista(aux)
          if (data.data.result.file) {
            setFileName(data.data.result.file)
            setSelectedFile(new File([], data.data.result.file, { type: 'application/pdf' }));
          } else {
            setFileName('')
            setSelectedFile(null);
          }
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print('handle_editar_cabecalho', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }

  }
  const handle_delete_cabecalho = async () => {
    try {
      set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
      setIsLoading(true);
      let data = await del(auth.token.cookie_token, `delete__reg_operacoes_culturais_cabecalho/${obj_anexo_cabecalho?.id_regsto_oper_cult_cabecalho}`)
      if (data.status === 200) {
        let lista_aux: any = obj_anexo_cabecalho_lista?.filter((el) =>
          el.id_regsto_oper_cult_cabecalho !== obj_anexo_cabecalho?.id_regsto_oper_cult_cabecalho
        );
        setMessage("Eliminado com sucesso!");

        setOpenSnackSuccess(true);
        set_obj_anexo_cabecalho_lista(lista_aux === undefined ? [] : lista_aux)
        set_obj_anexo_cabecalho_selecionado(undefined)
        set_obj_anexo_cabecalho(undefined)
        set_obj_anexo_cabecalho_to_edit(undefined)
        set_flag_editar_cabecalho(true)
        setSelectedFile(null)
        setFileName('')

      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {

      func_print('handle_delete_cabecalho', error, true)
      setIsLoading(false);

      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
    }
  }

  const handleEdit = () => {
    set_open_dialog_editar_ficheiro(true);
  };

  const handleConfirmEdit = () => {
    set_open_dialog_editar_ficheiro(false);
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDelete = () => {
    set_open_dialog_eliminar_ficheiro(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setIsLoading(true);

      const payload = {
        payload: {
          ...obj_anexo_cabecalho,
        }
      };

      const response = await post(auth.token.cookie_token,
        `/update_file_reg_operacoes_culturais_cabecalho`,
        payload
      );

      if (response.status === 200) {
        setSelectedFile(null);
        setFileName("");
        set_open_dialog_eliminar_ficheiro(false);
        setMessage("Documento eliminado com sucesso!");
        setOpenSnackSuccess(true);
        setSelectedFile(null)
        let aux = obj_anexo_cabecalho_lista?.map((el) => {
          if (el.id_regsto_oper_cult_cabecalho === response.data.result.id_regsto_oper_cult_cabecalho) {
            return response.data.result
          } else {
            return el
          }
        })

        set_obj_anexo_cabecalho_lista(aux)
      } else {
        setMessage("Erro ao eliminar o documento!");
        setOpenSnackError(true);
      }
    } catch (error) {
      func_print('handleConfirmDelete', error, true);
      setMessage("Erro ao eliminar o documento!");
      setOpenSnackError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewDocument = () => {
    if (selectedFile) {
      set_pdf_link(fileName);
      set_open_modal_show_pdf(true);
    }
  };

  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);

  return (
    <form>
      <CustomThemeProvider>
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {
            open_modal_add_edit_contador === true ?
              <Modaladdeditcontador
                lista_contadores={lista_contadores}
                flag_open_modal={open_modal_add_edit_contador}
                set_flag_open_modal={set_open_modal_add_edit_contador}
                setMessage={setMessage}
                setOpenSnackSuccess={setOpenSnackSuccess}
                setOpenSnackError={setOpenSnackError}
                set_flag_criar_contador={set_flag_criar_contador}
                flag_criar_contador={flag_criar_contador}
                set_lista_contadores={set_lista_contadores}
              />
              : <></>
          }

          {isLoading ?
            <LoadingVulpesSmall />
            :
            <Toolbar
              style={{
                paddingTop: 3,
                paddingBottom: 10,
                fontFamily: "candara",
                display: "flex",
                flexDirection: 'column',
              }}
            >
              <div style={{
                width: '100%',
              }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingBottom: 10
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: 'row',
                    }}
                  >
                    <h1
                      style={{
                        fontWeight: 600,
                        fontSize: 20,
                        fontFamily: "candara",
                      }}
                    >
                      5 - Registo de Operações Culturais
                    </h1>
                    <BasicPopover
                      text={
                        "Registo obrigatório para as intervenções Agricultura Biológica e Produção Integrada. \nQuando existir acumulação (quando permitida) com as intervenções: Conservação do Solo - Sementeira Direta, Conservação do Solo - Enrelvamento, Uso Eficiente da Água, Apoio Zonal Peneda-Gerês - manutenção de socalcos, Apoio Zonal Montesinho-Nogueira - manutenção de rotação de sequeiro cereal-pousio, Apoio Zonal Douro Internacional, Sabor, Maçãs e Vale do Côa - manutenção de rotação de sequeiro cereal-pousio, Apoio Zonal Castro Verde, Vale do Guadiana, Piçarras e Cuba - manutenção de rotação de sequeiro cereal-pousio-pastagens temporárias naturais e Apoio Zonal Alto e Centro Alentejo - manutenção de rotação de sequeiro cereal-pousio-pastagens temporárias naturais, o preenchimento do registo 5 dispensa o preenchimento do registo 5A e 5B. \n\nPretende-se que se registe todo o tipo de intervenção efetuado ao nível da parcela agrícola ou zona homogénea e por cultura, como por exemplo a aplicação de fertilizantes com base no plano de fertilização, a utilização de cultivares resistentes e ou material de propagação vegetativa categoria normalizada ou certificada, controlo de infestantes, como a monda manual, mobilização do solo, limpeza e preparação do terreno. Incluir também podas sanitárias, destruição e queima da lenha, desinfeção de utiensilios, entre outros."
                      }
                    />
                  </div>
                  <div>
                    {obj_anexo_cabecalho === undefined ? <></> : selectedFile === null ?
                      is_historico === true ? <></> :

                        <Button
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          startIcon={<FileUploadIcon />}
                          style={{
                            backgroundColor: cores.cor1,
                            maxHeight: 30,
                            width: 250,
                            marginRight: 10
                          }}
                        >
                          Carregar documento
                          <input
                            type="file"
                            accept="application/pdf"
                            hidden
                            multiple={false}
                            onChange={(event) => {
                              const file = event.target.files?.[0];
                              if (file) {
                                uploadDocumento(file);
                              }
                            }}
                          />
                        </Button>
                      :
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Button
                          style={{
                            backgroundColor: cores.cor1,
                            color: 'white',
                            maxHeight: 30,
                            width: 200,
                          }}
                          startIcon={<VisibilityIcon />}
                          onClick={handleViewDocument}
                        >
                          Ver documento
                        </Button>
                        {
                          is_historico === true ? <></> :
                            <>
                              <Button
                                style={{
                                  backgroundColor: cores.cor1,
                                  color: 'white',
                                  minWidth: '40px',
                                  maxHeight: 30,
                                }}
                                onClick={handleEdit}
                              >
                                <FileUploadIcon />
                              </Button>
                              <Button
                                style={{
                                  backgroundColor: cores.cor1,
                                  color: 'white',
                                  minWidth: '40px',
                                  maxHeight: 30,
                                }}
                                onClick={handleDelete}
                              >
                                <DeleteIcon />
                              </Button>
                              <input
                                ref={fileInputRef}
                                type="file"
                                accept="application/pdf"
                                hidden
                                multiple={false}
                                onChange={(event) => {
                                  const file = event.target.files?.[0];
                                  if (file) {
                                    setSelectedFile(file);
                                    uploadDocumento(file);
                                  }
                                }}
                              />
                            </>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div style={{
                  width: '100%',
                  display: "flex",
                  flexDirection: 'row',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',
                }}>
                  {
                    is_historico === true ? <></> :

                      especie_ou_lote_homegenio_lista.length === 0 ? <></> :

                        obj_anexo_cabecalho === undefined ?
                          <ButtonCadernos
                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_criar_cabecalho() }}
                          />
                          :
                          flag_editar_cabecalho === true ?
                            <ButtonCadernos
                              mostrarBotaoCancelar
                              aoClicarCancelar={() => {
                                if (flag_editado) {
                                  set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                } else {
                                  set_error_esperada(false)
                                  set_error_leitura_contador_preimeira(false)
                                  set_error_n_contador(false)
                                  set_error_obtida(false)
                                  set_error_producao_total(false)
                                  set_error_n_plantas(false)
                                  if (obj_anexo_cabecalho_backup) {
                                    set_obj_anexo_cabecalho_to_edit(obj_anexo_cabecalho_backup); // restaura o estado original
                                  }
                                  set_flag_editar_cabecalho(false)
                                }

                              }}
                              mostrarBotaoGravar
                              aoClicarGravar={() => { handle_editar_cabecalho() }}
                            /> :
                            <ButtonCadernos
                              mostrarBotaoApagar
                              mostrarBotaoEditar
                              aoClicarApagar={() => (set_open_dialog_tem_a_certeza_que_quer_eliminar(true))}
                              aoClicarEditar={() => {
                                set_flag_editar_cabecalho(true)
                              }}
                            />
                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                  }}>
                    Zona Homogénea
                    <Select
                      value={especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? '' : especie_ou_lote_homegenio_selecionada?.zona_homogenea}
                      label={''}
                      name={'zona_homogenea'}
                      sx={{
                        fontSize: 14,
                        fontFamily: "verdana",
                        minWidth: 200,
                      }}
                      onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                    >
                      {especie_ou_lote_homegenio_lista.sort((a, b) =>
                        (a.zona_homogenea ?? '').localeCompare(b.zona_homogenea ?? '', 'pt', {
                          sensitivity: 'base',
                        })
                      ).map((item: IZonaHomogenea, key) => {
                        return (
                          <MenuItem key={key} value={item.zona_homogenea}>
                            <Typography
                              style={{
                                fontSize: 14,
                                fontFamily: "candara",
                              }}
                            >
                              {item.zona_homogenea}
                            </Typography>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.15,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    <BasicPopover
                      text={
                        "Exploração em conversão para Produção Biológica (PB), assinalar: \nC1 - Primeiro ano de conversão para PB; \nC2 - Segundo ano de conversão para PB; \nC3 - Terceiro ano de conversão para PB."
                      }
                    />
                    Conversão:
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.15,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    <FormGroup
                      onChange={onInputEditTableChange_cabecalho} >
                      <FormControlLabel
                        name="c_1"
                        label={
                          <Typography
                            fontFamily="candara"
                            fontSize={16}
                          >
                            C1
                          </Typography>
                        }
                        aria-readonly
                        value={obj_anexo_cabecalho_to_edit?.c_1}
                        control={
                          <Checkbox
                            checked={!!obj_anexo_cabecalho_to_edit?.c_1}
                            onChange={onInputEditTableChange_cabecalho}
                            name="c_1"
                            disabled={!flag_editar_cabecalho}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": {
                                color: "#C94F1E",
                              },
                            }}
                          />
                        }
                      />
                    </FormGroup>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.15,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    <FormGroup
                      onChange={onInputEditTableChange_cabecalho} >
                      <FormControlLabel
                        name="c_2"
                        label={
                          <Typography
                            fontFamily="candara"
                            fontSize={16}
                          >
                            C2
                          </Typography>
                        }
                        aria-readonly
                        value={obj_anexo_cabecalho_to_edit?.c_2}
                        control={
                          <Checkbox
                            checked={!!obj_anexo_cabecalho_to_edit?.c_2}
                            disabled={!flag_editar_cabecalho}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": {
                                color: "#C94F1E",
                              },
                            }}
                          />
                        }
                      />
                    </FormGroup>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.15,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    <FormGroup
                      onChange={onInputEditTableChange_cabecalho} >
                      <FormControlLabel
                        name="c_3"
                        label={
                          <Typography
                            fontFamily="candara"
                            fontSize={16}
                          >
                            C3
                          </Typography>
                        }
                        aria-readonly
                        value={obj_anexo_cabecalho_to_edit?.c_3}
                        control={
                          <Checkbox
                            checked={!!obj_anexo_cabecalho_to_edit?.c_3}
                            disabled={!flag_editar_cabecalho}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": {
                                color: "#C94F1E",
                              },
                            }}
                          />
                        }
                      />
                    </FormGroup>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.15,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                  }}>
                    Área (ha): {cultura_selecionada?.area === undefined ? '' : cultura_selecionada?.area.toFixed(2)}
                  </div>
                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.4,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    gap: 8,
                    border: '1px solid silver',
                    padding: 8,
                    borderRadius: 5,
                    maxWidth: 500
                  }}>
                    Cultura e variedade:
                    {!isEditingCultura ? (

                      <Select
                        value={cultura_selecionada?.cultura === undefined ? '' : cultura_selecionada?.cultura}
                        label={''}
                        name={'cultura'}
                        sx={{
                          fontSize: 14,
                          fontFamily: "verdana",
                          minWidth: 200,
                        }}
                        onChange={(e) => {
                          handle_change_cultura(e.target.value)

                        }}
                      >
                        {especie_ou_lote_homegenio_selecionada?.culturas.sort((a, b) =>
                          (a?.cultura ?? '').localeCompare(b?.cultura ?? '', 'pt', {
                            sensitivity: 'base',
                          })
                        ).map((item: any, key) => (
                          <MenuItem key={key} value={item.cultura}>
                            <Typography
                              style={{
                                fontSize: 14,
                                fontFamily: "candara",
                              }}
                            >
                              {item.cultura}
                            </Typography>
                          </MenuItem>
                        ))}
                      </Select>
                    ) : (
                      <CustomTextField
                        name="cultura"
                        minWidth={200}
                        value={cultura_selecionada?.cultura === undefined ? '' : cultura_selecionada?.cultura}
                        onChange={(e: any) => {

                          set_especie_ou_lote_homegenio_selecionada((old: any) => ({
                            ...old,
                            culturas: old.culturas.map((el: any) => {
                              if (el.cultura === cultura_selecionada?.cultura) {
                                return {
                                  ...el,
                                  cultura: e.target.value,
                                }
                              } else {
                                return el
                              }
                            })
                          }))
                          set_cultura_selecionada((old: any) => ({
                            ...old,
                            cultura: e.target.value,
                          }))
                        }}
                      />
                    )}
                    <div style={{
                      display: "flex"
                      // , alignSelf: "flex-start",
                    }}>
                      {
                        flag_editar_cabecalho === false ? <></> :
                          isEditingCultura ?
                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={() => { setIsEditingCultura(prev => !prev) }}
                            />
                            :
                            <ButtonCadernos
                              mostrarBotaoEditar

                              aoClicarEditar={() => { setIsEditingCultura(prev => !prev) }}
                            />
                      }


                    </div>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.3,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    <BasicPopover
                      text={
                        "Preencher apenas para cultura permanente."
                      }
                    />
                    Compasso:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="compasso"
                          value={obj_anexo_cabecalho_to_edit?.compasso === undefined ? '' : obj_anexo_cabecalho_to_edit?.compasso}
                          onChange={onInputEditTableChange_cabecalho}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.compasso === undefined ? '' : obj_anexo_cabecalho?.compasso}
                        </div>

                    }
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.3,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    <BasicPopover
                      text={
                        "Preencher apenas para cultura permanente."
                      }
                    />
                    Porta-enxerto:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="porta_enxerto"
                          value={obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? '' : obj_anexo_cabecalho_to_edit?.porta_enxerto}
                          onChange={onInputEditTableChange_cabecalho}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.porta_enxerto === undefined ? '' : obj_anexo_cabecalho?.porta_enxerto}
                        </div>

                    }

                  </div>
                </div>

                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    nº de plantas:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="n_plantas"
                          value={obj_anexo_cabecalho_to_edit?.n_plantas === undefined ? '' : obj_anexo_cabecalho_to_edit?.n_plantas}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_n_plantas}
                          helperText={error_n_plantas ? 'Apenas números são aceites' : ""}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.n_plantas === undefined ? '' : obj_anexo_cabecalho?.n_plantas}
                        </div>

                    }

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.4,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                  }}>
                    <BasicPopover
                      text={
                        "Preencher apenas para cultura permanente"
                      }
                    />
                    Data de plantação ou de sementeira:
                    {
                      flag_editar_cabecalho === true ?
                        <TextField
                          variant="filled"
                          type="date"
                          defaultValue={obj_anexo_cabecalho_to_edit?.date_platacao}
                          disabled={!flag_editar_cabecalho}
                          name="date_platacao"
                          value={obj_anexo_cabecalho_to_edit?.date_platacao === undefined ? '' : obj_anexo_cabecalho_to_edit?.date_platacao}
                          onChange={onInputEditTableChange_cabecalho}
                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.date_platacao === undefined ? '' : obj_anexo_cabecalho?.date_platacao}
                        </div>

                    }
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    Método de rega:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="metodo_rega"
                          value={obj_anexo_cabecalho_to_edit?.metodo_rega === undefined ? '' : obj_anexo_cabecalho_to_edit?.metodo_rega}
                          onChange={onInputEditTableChange_cabecalho}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.metodo_rega === undefined ? '' : obj_anexo_cabecalho?.metodo_rega}
                        </div>

                    }

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    <BasicPopover
                      text={
                        "Condutividade elétrica (ds/m) determinada através das análise à água de rega. \n\nPreenchimento obrigatório apenas para os beneficiários de PRODI"
                      }
                    />

                    C.E. (dS/m):
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="c_e"
                          value={obj_anexo_cabecalho_to_edit?.c_e === undefined ? '' : obj_anexo_cabecalho_to_edit?.c_e}
                          onChange={onInputEditTableChange_cabecalho}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.c_e === undefined ? '' : obj_anexo_cabecalho?.c_e}
                        </div>

                    }

                  </div>
                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    Produção total:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="producao_total"
                          value={obj_anexo_cabecalho_to_edit?.producao_total === undefined ? '' : obj_anexo_cabecalho_to_edit?.producao_total}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_producao_total}
                          helperText={error_producao_total ? 'Apenas números são aceites' : ""}
                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.producao_total === undefined ? '' : obj_anexo_cabecalho?.producao_total}
                        </div>

                    }
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',
                  }}>
                    Esperada (Ton/ha):

                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="esperada"
                          value={obj_anexo_cabecalho_to_edit?.esperada === undefined ? '' : obj_anexo_cabecalho_to_edit?.esperada}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_esperada}
                          helperText={error_esperada ? 'Apenas números são aceites' : ""}
                        />

                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.esperada === undefined ? '' : obj_anexo_cabecalho?.esperada}
                        </div>

                    }

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                  }}>
                    Obtida (Ton/ha):

                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="obtida"
                          value={obj_anexo_cabecalho_to_edit?.obtida === undefined ? '' : obj_anexo_cabecalho_to_edit?.obtida}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_obtida}
                          helperText={error_obtida ? 'Apenas números são aceites' : ""}
                        />

                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.obtida === undefined ? '' : obj_anexo_cabecalho?.obtida}
                        </div>

                    }

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                  }}>
                    <BasicPopover
                      text={
                        "Preenchimento obrigatório apenas para os beneficiários de PRODI quando não existe acumulação com a intervenção «Uso Eficiente da Água» e utilizam sistemas de rega sob pressão."
                      }
                    />
                    N.º do Contador:
                    <Select
                      disabled={!flag_editar_cabecalho}
                      value={contador_selecionado?.id_contador === undefined ? null : contador_selecionado?.id_contador}
                      label={''}
                      name={'n_contador'}
                      sx={{
                        fontSize: 14,
                        fontFamily: "verdana",
                        minWidth: 200,
                      }}
                      onChange={(e) => handle_change_contador(Number(e.target.value))}
                    >
                      <MenuItem value={'0'}>
                        <Typography
                          style={{
                            fontSize: 14,
                            fontFamily: "candara",
                          }}
                        >
                          {'Criar contador'}
                        </Typography>
                      </MenuItem>
                      {lista_contadores?.map((item: IContador, key) => {
                        return (
                          <MenuItem key={key} value={item.id_contador}>
                            <Typography
                              style={{
                                fontSize: 14,
                                fontFamily: "candara",
                              }}
                            >
                              {item.nome}
                            </Typography>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                  }}>
                    <BasicPopover
                      text={
                        "Preenchimento obrigatório apenas para os beneficiários de PRODI quando não existe acumulação com a intervenção «Uso Eficiente da Água» e utilizam sistemas de rega sob pressão."
                      }
                    />
                    Leitura do contador antes da 1.ª rega (m3):
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="leitura_contador_preimeira"
                          value={obj_anexo_cabecalho_to_edit?.leitura_contador_preimeira === undefined ? '' : obj_anexo_cabecalho_to_edit?.leitura_contador_preimeira}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_leitura_contador_preimeira}
                          helperText={error_leitura_contador_preimeira ? 'Apenas números são aceites' : ""}
                        />

                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.leitura_contador_preimeira === undefined ? '' : obj_anexo_cabecalho?.leitura_contador_preimeira}
                        </div>

                    }

                  </div>
                </div>
              </div>
            </Toolbar>
          }
        </TableContainer>
      </CustomThemeProvider>
      <ConfirmDialog
        open={open_dialog_tem_a_certeza_que_quer_eliminar}
        onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
        onConfirm={handle_delete_cabecalho}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
      <ConfirmDialog
        open={open_dialog_eliminar_ficheiro}
        onClose={() => set_open_dialog_eliminar_ficheiro(false)}
        onConfirm={handleConfirmDelete}
        message="Deseja eliminar o documento?"
      />
      <ConfirmDialog
        open={open_dialog_editar_ficheiro}
        onClose={() => set_open_dialog_editar_ficheiro(false)}
        onConfirm={handleConfirmEdit}
        message="Ao enviar um novo ficheiro substitui o atual. Pretender continuar?"
      />
      <Modalshowpdf
        open_modal_show_pdf={open_modal_show_pdf}
        set_open_modal_show_pdf={set_open_modal_show_pdf}
        link_file={pdf_link}
      />
    </form >

  );
};
